import { render, staticRenderFns } from "./Rewardform.vue?vue&type=template&id=c2f03024&"
import script from "./Rewardform.vue?vue&type=script&lang=js&"
export * from "./Rewardform.vue?vue&type=script&lang=js&"
import style0 from "./Rewardform.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports